import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { EaLoanModule } from '@app/components/ea-loan/ea-loan.module';
import { ComponentsModule } from '@app/components/components.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { EaEstateFormComponent } from './ea-estate-form/ea-estate-form.component';
import { EaEstateFormService } from './ea-estate-form/ea-estate-form.service';
import { EaEstateLoanFormComponent } from './ea-estate-loan-form/ea-estate-loan-form.component';
import { EaEstateLoanFormService } from './ea-estate-loan-form/ea-estate-loan-form.service';
import { EaEstatesFormComponent } from './ea-estates-form/ea-estates-form.component';
import { EaEstimationFormComponent } from './ea-estimation-form/ea-estimation-form.component';
import { EaEstimationFormService } from './ea-estimation-form/ea-estimation-form.service';
import { EaFeesFormComponent } from './ea-fees-form/ea-fees-form.component';
import { EaFeesFormService } from './ea-fees-form/ea-fees-form.service';
import { EaLmnplmpFormComponent } from './ea-lmnplmp-form/ea-lmnplmp-form.component';
import { EaLmnpLmpFormService } from './ea-lmnplmp-form/ea-lmnplmp-form.service';
import { EaRealestateFormComponent } from './ea-realestate-form/ea-realestate-form.component';
import { EaRealestateFormService } from './ea-realestate-form/ea-realestate-form.service';
import { EaRentFormComponent } from './ea-rent-form/ea-rent-form.component';
import { EaRentFormPersonalUseComponent } from './ea-rent-form-personal-use/ea-rent-form-personal-use.component';
import { EaRentFormPersonalUseService } from './ea-rent-form-personal-use/ea-rent-form-personal-use.service';
import { EaScpiFormComponent } from './ea-scpi-form/ea-scpi-form.component';
import { EaScpiFormService } from './ea-scpi-form/ea-scpi-form.service';

let COMPONENTS = [
  EaEstateFormComponent,
  EaEstatesFormComponent,
  EaEstateLoanFormComponent,
  EaEstimationFormComponent,
  EaFeesFormComponent,
  EaLmnplmpFormComponent,
  EaRealestateFormComponent,
  EaScpiFormComponent,
  EaRentFormComponent,
  EaRentFormPersonalUseComponent,
];

@NgModule({
  declarations: [COMPONENTS],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    EaLoanModule,
    MatSelectModule,
    TranslateModule,
    NgxMaskDirective,
    NgxMaskPipe,
    CommonModule,
  ],
  providers: [
    EaEstateFormService,
    EaEstateLoanFormService,
    EaEstimationFormService,
    EaFeesFormService,
    EaLmnpLmpFormService,
    EaRealestateFormService,
    EaScpiFormService,
    EaRentFormPersonalUseService,
    provideNgxMask(),
  ],
})
export class EstatesFormsModule {}
